var industryInfo={
    classList:[
        {
            'name':"协作机器人",
            'list':[
                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/case/zsxl.mp4",
                    'title':"注塑物料下料",
                    'lable':"注塑机内物料成型后，LM3机器人将物料吸附后抬起，将物料放入下一道工序。LM3机器人所有关节均可实现无限制旋转，可量身定制运动场景，应对复杂场景。",
                    'list':[
                        {
                            'icon':"/static/case/az.png",
                            'title':"安装简单"
                        },
                        {
                            'icon':"/static/case/gj360.png",
                            'title':"关节360°旋转"
                        },
                        {
                            'icon':"/static/case/aq.png",
                            'title':"安全保障"
                        }
                        ,
                        {
                            'icon':"/static/case/cjdz.png",
                            'title':"场景定制"
                        }
                    ],
                    'process':[
                        {
                            'icon':"/static/case/fz.png",
                            'title':"机器人吸附物料"
                        },
                        {
                            'icon':"/static/case/fj.png",
                            'title':"注塑机内取出物料"
                        },
                        {
                            'icon':"/static/case/fz.png",
                            'title':"放入传送带"
                        }

                    ]
                }
            ]
        },
        {
            'name':"3D视觉系统",
            'list':[
                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/case/FS820.mp4",
                    'title':"机床上下料",
                    'lable':"图漾3D相机对物料进行拍照识别，利用强大的软件和算法，对物料进行数据采集和定位，使机器人精准抓取、放置物料。",
                    'list':[
                        {
                            'icon':"/static/case/jd.png",
                            'title':"高精度"
                        },
                        {
                            'icon':"/static/case/clfwd.png",
                            'title':"大视野"
                        },
                        {
                            'icon':"/static/case/dlc.png",
                            'title':"多量程"
                        }
                        ,
                        {
                            'icon':"/static/case/zqlg.png",
                            'title':"准确率高"
                        }
                        
                    ]
                }
            ]
        },
        {
            'name':"伺服驱动器",
            'list':[
                {
                    'videoUrl':"",
                    'picUrl':"/static/industry/jg.jpg",
                    'title':"CoolDrive S7在平面激光切割设备上的应用",
                    'lable':"方案可应用于激光切割、激光切管、激光焊接、激光打标设备、全自动落料线等设备。",
                    'list':[
                        {
                            'icon':"/static/case/dlhzq.png",
                            'title':"电流环周期31.25μs,系统响应速度更快"
                        },
                        {
                            'icon':"/static/case/zglsfdj.png",
                            'title':"中惯量伺服电机,运行更稳定"
                        },
                        {
                            'icon':"/static/case/23wjdzbmq.png",
                            'title':"23位绝对值编码器,定位精度更高"
                        },
                        {
                            'icon':"/static/case/ethercat.png",
                            'title':"EtherCAT/脉冲等多种控制方式配置灵活"
                        },
                        {
                            'icon':"/static/case/zcgjdlm.png",
                            'title':"支持高精度龙门同步功能,精准高效"
                        },
                    ]
                }
            ]
        },
        {
            'name':"RV减速机",
            'list':[
                {
                    'picUrl':"https://image.sjyuan.net.cn/video/mvb/case/%E6%9C%BA%E6%A2%B0%E8%AE%BE%E5%A4%87%28CRDS-C%29.jpg",
                    'title':"CT-CRD-C系列减速机在木工5轴加工中心上的应用",
                    'lable':"满足定位精度高的使用要求，价格低。",
                    'list':[
                        {
                            'icon':"/static/case/zksj.png",
                            'title':"中空设计"
                        },
                        {
                            'icon':"/static/case/az.png",
                            'title':"安装方便"
                        },
                        {
                            'icon':"/static/case/rhzfr.png",
                            'title':"润滑脂已封入"
                        }
                        ,
                        {
                            'icon':"/static/case/jd.png",
                            'title':"高精度，误差小于1弧分"
                        }
                        ,
                        {
                            'icon':"/static/case/ngz.png",
                            'title':"耐过载"
                        }
                        ,
                        {
                            'icon':"/static/case/xn.png",
                            'title':"良好的加减速性能"
                        }
                    ]
                }
            ]
        },
       
    ],
    name:"机械设备",
    title:"solutions",
    subtitle:"机械设备应用案例",
    subinfo:"我们的应用案例包括为机械设备制造行业提供伺服驱动器、减速机等服务，可为印刷机械、包装机械、纺织机械、橡塑机械、机床机械提供支持。",
}

export default {
    industryInfo
  };    


// WEBPACK FOOTER //
// ./src/data/industryInfo/8.js